import React from 'react';
import { appHasEditor, newAppHasEditor, enableDeleteMLApp, getAppDashboardDataNew, getAppPages, getAppWidgets, getEditorPlatformComps, getEditorWebComps, isPremiumFromBundle, } from '../../../utils/appUtils';
import { EditorType, Origin } from '../../manage-installed-apps-page';
import { useExperiments } from '@wix/wix-experiments-react';
import { DeleteDashboardModal } from './delete-dashboard-modal';
import { DeleteWidgetAppModal } from './delete-widget-modal';
import { DeleteHybridAppModal } from './delete-hybrid-modal';
import { DeletePageAppModal } from './delete-page-modal';
import { DeletePremiumModal } from './delete-premium-modal';
import { DeleteEditorModalFromBM } from './delete-editor-modal-from-BM';
import { RenewalType as RenewalTypeNew } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
export function DeleteModal({ app, msId, origin, editorUrl, deleteApp, closeModal, editorType, baseUrl, authorizationHeader, openDeleteModalAppInEditor, }) {
    const { experiments } = useExperiments();
    const activePremiumNew = app?.premiumInfo?.isUpgraded &&
        app?.premiumInfo?.renewalType !== RenewalTypeNew.AUTO_RENEW_OFF;
    const appNameFromData = app?.appInfo?.name;
    const appName = appNameFromData?.replace('&amp;', '&');
    const appId = app?.appId;
    const activePremium = activePremiumNew;
    const shouldShowPremiumModal = activePremium && !isPremiumFromBundle(app);
    if (shouldShowPremiumModal) {
        return (React.createElement(DeletePremiumModal, { appId: appId, appName: appName, handleClose: closeModal, msId: msId }));
    }
    if ((enableDeleteMLApp(appId, experiments) && origin === Origin.BIZMGR) ||
        (editorType !== EditorType.ADI &&
            appId !== '14d84998-ae09-1abf-c6fc-3f3cace5bf19' &&
            (experiments.enabled('specs.app-market.BlocksUninstallFix')
                ? newAppHasEditor(app)
                : appHasEditor(app)) &&
            origin === Origin.BIZMGR)) {
        return (React.createElement(DeleteEditorModalFromBM, { appId: appId, appName: appName, handleClose: closeModal, openDeleteModalAppInEditor: openDeleteModalAppInEditor, msid: msId }));
    }
    if ((editorType !== EditorType.ADI &&
        (experiments.enabled('specs.app-market.BlocksUninstallFix')
            ? newAppHasEditor(app)
            : appHasEditor(app)) &&
        origin === Origin.EDITOR &&
        appId !== '14d84998-ae09-1abf-c6fc-3f3cace5bf19') ||
        enableDeleteMLApp(appId, experiments)) {
        return (React.createElement(DeleteDashboardModal, { app: app, msId: msId, origin: origin, handleClose: closeModal, handleDeleteApp: deleteApp, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, showNotification: false }));
    }
    if (!(experiments.enabled('specs.app-market.BlocksUninstallFix')
        ? newAppHasEditor(app)
        : appHasEditor(app)) ||
        getEditorWebComps(app).length > 0) {
        return (React.createElement(DeleteDashboardModal, { app: app, msId: msId, origin: origin, handleClose: closeModal, handleDeleteApp: deleteApp, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, showNotification: true }));
    }
    if (getAppPages(app).length) {
        return (React.createElement(DeletePageAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    if (getAppWidgets(app).length || getEditorPlatformComps(app).length) {
        return (React.createElement(DeleteWidgetAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    if ((experiments.enabled('specs.app-market.BlocksUninstallFix')
        ? newAppHasEditor(app)
        : appHasEditor(app)) &&
        getAppDashboardDataNew(app)) {
        return (React.createElement(DeleteHybridAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
    else {
        return (React.createElement(DeleteWidgetAppModal, { appName: appName, origin: origin, editorUrl: editorUrl, handleClose: closeModal }));
    }
}
//# sourceMappingURL=delete-modal.js.map